export default __webpack_public_path__ + "static/make-offer-ad55ac9f6e564b969221b07bf626a36a.jpg";